yTos.utils.namespace('yTos.configuration.requireJSConfig.paths');

yTos.configuration.requireJSConfig.paths['common.gmap'] = 'common.gmap-1.2.3/common.gmap';
yTos.configuration.requireJSConfig.paths['common.guestWishListManager'] = 'common.guestWishListManager-0.2.0/common.guestWishListManager';
//yTos.configuration.requir0.1.6/common.guestWishListManager/src/common.guestWishListManager';

yTos.configuration.requireJSConfig.paths['service.imageConverterAkamai'] = 'service.imageConverterAkamai-1.0.3/service.imageConverterAkamai';
yTos.configuration.requireJSConfig.paths['service.imageConverterCloudinary'] = 'service.imageConverterCloudinary-1.3.2/service.imageConverterCloudinary';
yTos.configuration.requireJSConfig.paths['service.imageConverterAkamaiImageManager'] = 'service.imageConverterAkamaiImageManager-1.1.3/service.imageConverterAkamaiImageManager';
yTos.configuration.requireJSConfig.paths['service.imageConverterImageSphere'] = 'service.imageConverterImageSphere-1.0.1/service.imageConverterImageSphere';

yTos.configuration.requireJSConfig.paths['ui.checkoutWarnings'] = 'ui.checkoutWarnings-1.3.3/ui.checkoutWarnings';
yTos.configuration.requireJSConfig.paths['ui.addressHintExt'] = 'ui.addressHintExt-0.5.1/ui.addressHintExt';
yTos.configuration.requireJSConfig.paths['ui.ajaxForm'] = 'ui.ajaxForm-2.12.0/ui.ajaxForm';
//yTos.configuration.requireJSConfig.paths['ui.ajaxForm'] = '/jsrepo/ui.ajaxForm/src/ui.ajaxForm';
yTos.configuration.requireJSConfig.paths['ui.scrollToError'] = 'ui.scrollToError-1.0.8/ui.scrollToError';
yTos.configuration.requireJSConfig.paths['ui.geolocalization'] = 'ui.geolocalization-0.1.0/ui.geolocalization';

// ui.confirmationAlert is deprecated!
// use ui.confirmLayer instead.
yTos.configuration.requireJSConfig.paths['ui.confirmationAlert'] = 'ui.confirmationAlert-1.0.7/ui.confirmationAlert';
yTos.configuration.requireJSConfig.paths['ui.confirmLayer'] = 'ui.confirmLayer-1.4.0/ui.confirmLayer';

yTos.configuration.requireJSConfig.paths['ui.creditCardExpirationDate'] = 'ui.creditCardExpirationDate-1.0.11/ui.creditCardExpirationDate';
yTos.configuration.requireJSConfig.paths['ui.creditCardNumberExt'] = 'ui.creditCardNumberExt-0.2.7/ui.creditCardNumberExt';
yTos.configuration.requireJSConfig.paths['ui.creditCardTypeGuesser'] = 'ui.creditCardTypeGuesser-1.0.5/ui.creditCardTypeGuesser';
yTos.configuration.requireJSConfig.paths['ui.datePicker'] = 'ui.datePicker-1.1.5/ui.datePicker';
yTos.configuration.requireJSConfig.paths['ui.layer'] = 'ui.layer-1.10.4/ui.layer';
yTos.configuration.requireJSConfig.paths['ui.imageHelper'] = 'ui.imageHelper-1.2.0/ui.imageHelper';

yTos.configuration.requireJSConfig.paths['ui.map'] = 'ui.map-2.0.3/ui.map';
yTos.configuration.requireJSConfig.paths['ui.picturePolyfill'] = 'ui.picturePolyfill-1.1.3/ui.picturePolyfill';

// ui.provinces is deprecated
// use ui.cnProvinces instead
yTos.configuration.requireJSConfig.paths['ui.provinces'] = 'ui.provinces-1.3.9/ui.provinces';
yTos.configuration.requireJSConfig.paths['ui.cnProvinces'] = 'ui.cnProvinces-1.2.0/ui.cnProvinces';
yTos.configuration.requireJSConfig.paths['ui.radioGroup'] = 'ui.radioGroup-2.0.1/ui.radioGroup';
yTos.configuration.requireJSConfig.paths['ui.recaptcha'] = 'ui.recaptcha-2.4.1/ui.recaptcha';

yTos.configuration.requireJSConfig.paths['ui.selectAsList'] = 'ui.selectAsList-1.3.2/ui.selectAsList';
yTos.configuration.requireJSConfig.paths['ui.sessionLayer'] = 'ui.sessionLayer-2.0.0/ui.sessionLayer';
yTos.configuration.requireJSConfig.paths['ui.slider'] = 'ui.slider-1.1.4/ui.slider';
yTos.configuration.requireJSConfig.paths['ui.zipCode'] = 'ui.zipCode-1.2.5/ui.zipCode';

yTos.configuration.requireJSConfig.paths['ui.inspector'] = 'debug.inspector-1.4.2/debug.inspector';

yTos.configuration.requireJSConfig.paths['async'] = 'vendor.async-1.0.0/vendor.async';

yTos.configuration.requireJSConfig.paths['vendor.gmaps'] = 'vendor.gmaps-1.1.1/vendor.gmaps';
yTos.configuration.requireJSConfig.paths['vendor.googlePlaces'] = 'vendor.googlePlaces-1.2.1/vendor.googlePlaces';
yTos.configuration.requireJSConfig.paths['vendor.lazyload'] = 'vendor.lazyload-4.0.0/vendor.lazyload';
yTos.configuration.requireJSConfig.paths['vendor.picturefill'] = 'vendor.picturefill-2.0.0/vendor.picturefill';
yTos.configuration.requireJSConfig.paths['vendor.selectize'] = 'vendor.selectize-1.2.1/vendor.selectize';
yTos.configuration.requireJSConfig.paths['vendor.pinchZoom'] = 'vendor.pinchZoom-2.3.2';
yTos.configuration.requireJSConfig.paths['vendor.adyen'] = 'vendor.adyen-0.2.0/vendor.adyen';
yTos.configuration.requireJSConfig.paths['adyen-sdk'] = 'https://checkoutshopper-live.adyen.com/checkoutshopper/sdk/3.0.0/adyen';


// Use this to load js helper from your filesystem
// yTos.configuration.requireJSConfig.paths['ui.provinces'] = '/jsrepo/ui.provinces/src/ui.provinces';
